import { render, staticRenderFns } from "./ReturnTransferAccess.vue?vue&type=template&id=4f4cc489&scoped=true"
import script from "./ReturnTransferAccess.vue?vue&type=script&lang=js"
export * from "./ReturnTransferAccess.vue?vue&type=script&lang=js"
import style0 from "./ReturnTransferAccess.vue?vue&type=style&index=0&id=4f4cc489&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4cc489",
  null
  
)

export default component.exports